export const ROW_HEIGHT = 118;
export const ROW_HEIGHT_COMPACT = 80;
export const HEADER_HEIGHT = 57;
export const PAGINATION_PAGE_SIZE = 30;
export const TOOLTIP_SHOW_DELAY = 200;
export const TOOLTIP_HIDE_DELAY = 2000;
